import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/logistics/v3/'

/**
 * 入库单列表
 * @param {Object} params
 */
export const getWarehousingOrderList = params => axios({
  url: `${commonPath}warehousing/order/list`,
  method: 'post',
  data: params
})

/**
 * 入库单类型
 * @param {Object} params
 */
export const getWarehousingOrderType = params => axios({
  url: `${commonPath}picking_type/list`,
  method: 'post',
  data: params
})

/**
 * 入库单详情
 * @param {String} id
 */
export const getWarehousingOrderInfo = id => axios({
  url: `${commonPath}warehousing/order/detail/${id}`,
  method: 'get'
})

/**
 * 入库单编辑
 * @param {Object} params
 */
export const editWarehousingOrder = params => axios({
  url: `${commonPath}warehousing/order`,
  method: 'put',
  data: params
})

/**
 * 入库单-收货项
 * @param {Object} params
 */
export const getWarehousingReceiptList = params => axios({
  url: `${commonPath}warehousing/picking/line/list`,
  method: 'post',
  data: params
})

/**
 * 入库项列表
 * @param {Object} params
 */
export const getWarehousingLineList = params => axios({
  url: `${commonPath}warehousing/line/list`,
  method: 'post',
  data: params
})

/**
 * 目标库位
 */
export const getWarehousingTargetLot = () => axios({
  url: `${commonPath}warehousing/target_lot/list`,
  method: 'get'
})

/**
 * 入库项分拣人
 */
export const getWarehousingLineMember = () => axios({
  url: `${commonPath}warehousing/line/member/all`,
  method: 'get'
})

/**
 * 入库项详情
 * @param {String} id
 */
export const getWarehousingLineOrderInfo = id => axios({
  url: `${commonPath}warehousing/detail/${id}`,
  method: 'get'
})

/**
 * 入库项编辑
 * @param {Object} params
 */
export const editWarehousingLine = params => axios({
  url: `${commonPath}warehousing/line`,
  method: 'put',
  data: params
})

/**
 * 分拣
 * @param {Object} params
 */
export const warehousingLineSorting = params => axios({
  url: `${commonPath}warehousing/order`,
  method: 'post',
  data: params
})

/**
 * 入库项-品检项
 * @param {Object} params
 */
export const getWarehousingLineQcTest = params => axios({
  url: `${commonPath}warehousing/line/qc_test/list`,
  method: 'post',
  data: params
})

/**
 * 入库项-收货项
 * @param {Object} params
 */
export const getWarehousingLineReceiptList = params => axios({
  url: `${commonPath}warehousing/line/picking_line/list`,
  method: 'post',
  data: params
})

/**
 * 入库项-联系人
 * @param {Object} params
 */
export const getWarehousingLineContacts = params => axios({
  url: `${commonPath}warehousing/line/contacts`,
  method: 'post',
  data: params
})
